import styled from 'styled-components';
import { asRem } from 'utils';
import { breakpoints } from 'components/Theme';

export default styled.div`
  &.webplayer--zpp-course {
    .player-container > div {
      position: relative;

      .player {
        padding-top: ${asRem(8)};

        @media (min-width: ${breakpoints.lg}) {
          padding-top: ${asRem(42)};
        }
      }
    }
  }

  .zpp-course-remove-teaser {
    left: ${asRem(16)};
    right: ${asRem(16)};
    width: calc(100% - ${asRem(32)});

    @media (min-width: ${breakpoints.lg}) {
      left: 0;
      right: 0;
      width: 100%;
    }
  }
`;
